import { useEffect, useRef, useState } from 'react';

const advantages = [
  {
    icon: 'ri-team-line',
    title: '专业团队',
    desc: '拥有丰富经验的调查专家，熟悉各类调查技巧和法律法规',
    num: '01',
  },
  {
    icon: 'ri-lock-password-line',
    title: '严格保密',
    desc: '所有委托信息和调查过程严格保密，保障客户隐私',
    num: '02',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效服务',
    desc: '快速响应客户需求，高效开展调查，及时反馈结果',
    num: '03',
  },
  {
    icon: 'ri-scales-3-line',
    title: '合法合规',
    desc: '所有调查活动严格遵守法律法规，确保证据合法有效',
    num: '04',
  },
];

const AdvantagesSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="py-20 bg-[#0a1209] relative overflow-hidden">
      {/* Decorative lines */}
      <div className="absolute inset-0 pointer-events-none opacity-5"
        style={{
          backgroundImage: 'repeating-linear-gradient(45deg, rgba(201,168,76,0.5) 0, rgba(201,168,76,0.5) 1px, transparent 0, transparent 50%)',
          backgroundSize: '30px 30px'
        }}
      ></div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-8 h-px bg-gradient-to-r from-transparent to-[#c9a84c]"></span>
            <span className="text-[#c9a84c] text-xs font-semibold tracking-widest uppercase">Why Choose Us</span>
            <span className="w-8 h-px bg-gradient-to-l from-transparent to-[#c9a84c]"></span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2">我们的优势</h2>
          <p className="text-white/35 text-sm">为什么选择猎鹰侦探事务所</p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((a, idx) => (
            <div
              key={a.title}
              className="relative text-center p-7 rounded-xl bg-[#162218] border border-[#c9a84c]/10 hover:border-[#c9a84c]/50 transition-all duration-500 group overflow-hidden cursor-default"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0) scale(1)' : 'translateY(24px) scale(0.97)',
                transition: `opacity 0.6s ease ${idx * 0.12}s, transform 0.6s ease ${idx * 0.12}s, border-color 0.3s ease`,
              }}
            >
              {/* Animated top border glow */}
              <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/0 to-transparent group-hover:via-[#c9a84c]/80 transition-all duration-500 pointer-events-none"></span>

              {/* Number watermark */}
              <span className="absolute top-2 right-3 text-6xl font-black text-[#c9a84c]/6 select-none leading-none group-hover:text-[#c9a84c]/12 transition-colors duration-500">
                {a.num}
              </span>

              {/* Icon with ring animation */}
              <div className="relative w-16 h-16 flex items-center justify-center mx-auto mb-5">
                <span className="absolute inset-0 rounded-full border border-[#c9a84c]/20 group-hover:border-[#c9a84c]/60 group-hover:scale-110 transition-all duration-500"></span>
                <span className="absolute inset-2 rounded-full bg-[#c9a84c]/8 group-hover:bg-[#c9a84c]/20 transition-colors duration-500"></span>
                <i className={`${a.icon} text-2xl text-[#c9a84c] relative z-10`}></i>
              </div>

              <h3 className="text-base font-bold text-white mb-2 group-hover:text-[#c9a84c] transition-colors duration-300">{a.title}</h3>
              <p className="text-xs text-white/45 leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
